import React from 'react';

import { ViewContainer } from '@/components/pages/Service/Detail/View';

export const ServiceDetailPage: React.FC = () => {
  return <ViewContainer />;
};
